export function classList(classes: { [s: string]: unknown; } | ArrayLike<unknown>) {
  return Object.entries(classes)
    .filter(entry => entry[1])
    .map(entry => entry[0])
    .join(' ');
}
